import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { RebalancingHistDTO } from "@core/dto/rebalance-hist-dto-model";
import { ResponseList } from "@core/models/interfaces/response-list.interface";
import { DeviceModel, RebalancingModel } from "@core/models/rebalancing-model.model";
import { environment } from "@environment";
import { Observable } from "rxjs";
import { IStateHistoryFilters } from "src/app/main/modules/fleet/pages/state-history/state-history.component";

type DeviceResponse = {
	devices: Array<DeviceModel>,
	message: string,
}

@Injectable({
    providedIn: 'root',
})
export class RebalancesService {
    #apiUrl = `${environment.api_url}/v2`;
    #http = inject(HttpClient);

	getList(page: number, pageSize: number, filters: IStateHistoryFilters): Observable<any> {
		const params = new HttpParams({
			fromObject: {
				page,
				pageSize,
				filters: JSON.stringify(filters)
			}
		});
		return this.#http.get<ResponseList<RebalancingModel>>(`${this.#apiUrl}/services/rebalance`, {params});
	}

	getListHistory(page: number, pageSize: number, filters: IStateHistoryFilters): Observable<any> {
		const params = new HttpParams({
			fromObject: {
				page,
				pageSize,
				filters: JSON.stringify(filters)
			}
		});

		return this.#http.get<ResponseList<RebalancingHistDTO>>(`${this.#apiUrl}/services/rebalance/hist`, { params });
	}

    getDevices(locationId: number) {
		return this.#http.get<DeviceResponse>(`${this.#apiUrl}/services/rebalance/devices/${locationId}`)
	}

	sendRebalancingData(data: any, rebalanceId: number, documentFile?: any) {
		const formData = new FormData();
		
		formData.append('files', documentFile);
		formData.append('data', data);

		return this.#http.post<any>(`${this.#apiUrl}/services/rebalance/step/${rebalanceId}`, formData);
	}

	sendLastRebalancingData(data: any, rebalanceId: number, documentFile?: any) {
		const formData = new FormData();
		
		formData.append('files', documentFile);
		formData.append('data', data);

		return this.#http.post<any>(`${this.#apiUrl}/services/rebalance/last-step/${rebalanceId}`, formData);
	}

	getRebalancing(rebalacing_id: number) {
		return this.#http.get<RebalancingModel>(`${this.#apiUrl}/rebalances/${rebalacing_id}`);
	}

	resetRebalancing(rebalanceId: number) {
		return this.#http.post<void>(`${this.#apiUrl}/rebalances/reset-steps/${rebalanceId}`, null);
	}
}